import React, { useState, useEffect } from "react";
import { IdcardOutlined, ToolOutlined, UserOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Steps } from "antd";
import { useRouter } from "next/router";
import PersonalInformation from "./personal-information/personal-information";
import WorkInformation from "./work-information/work-information";
import Skills from "./skills/skills";
import gql from "graphql-tag";
import { useQuery, useMutation } from "@apollo/react-hooks";
import Head from "next/head";
import { useAuth } from "../../../components/common/authProvider/AuthProvider";

import styles from "./styles.module.css";
import { useBrand } from "../../../utils/brandContext";

export const STATES = gql`
  query {
    states {
      name
      sName
      id
    }
  }
`;
export const SKILLS = gql`
  query {
    skills {
      id
      sName
      name
    }
  }
`;
export const HEARABOUTUS = gql`
  query {
    channels {
      id
      name
      sName
    }
  }
`;
export const WORK_PERIODS = gql`
  query {
    workPeriods(orderBy: sName_ASC) {
      id
      name
      sName
    }
  }
`;
export const SIGNUP_MUTATION_WORKER = gql`
  mutation SIGNUP_MUTATION_WORKER(
    $email: String!
    $firstName: String!
    $lastName: String!
    $password: String!
    $skills: [SkillWhereUniqueInput!]!
    $position: String!
    $facilityName: String!
    $facilityStreet: String!
    $city: String!
    $zipCode: String!
    $channel: ChannelWhereUniqueInput!
    $workPeriod: WorkPeriodWhereUniqueInput!
    $state: StateWhereUniqueInput!
    $phone: String!
    $referredBy: Int
    $recaptcha: String!
    $homeCity: String!
    $homeState: StateWhereUniqueInput!
    $homeStreet: String!
    $homeZipCode: String!
  ) {
    signupWorker(
      firstName: $firstName
      lastName: $lastName
      email: $email
      password: $password
      position: $position
      facilityName: $facilityName
      facilityStreet: $facilityStreet
      city: $city
      skills: $skills
      state: $state
      channel: $channel
      zipCode: $zipCode
      phone: $phone
      workPeriod: $workPeriod
      referredBy: $referredBy
      recaptcha: $recaptcha
      homeCity: $homeCity
      homeState: $homeState
      homeStreet: $homeStreet
      homeZipCode: $homeZipCode
    ) {
      token
      user {
        id
      }
    }
  }
`;
const formItemLayout = {
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 23 },
  },
};

const { Step } = Steps;
/**
 * renderComponent
 * @component
 * @namespace SignUp
 * @summary worker can sign up
 * @return {React} React component view
 */
const SignUpWorker = (props) => {
  const brand = useBrand();
  const { form, admin, setVisible } = props;
  const { getFieldsValue, validateFields, getFieldDecorator, setFieldsValue } =
    form;
  const [current, setCurrent] = useState(0);
  const states = useQuery(STATES);
  const skills = useQuery(SKILLS);
  const hearAboutUs = useQuery(HEARABOUTUS);
  const workPeriods = useQuery(WORK_PERIODS);
  const [signUp, { called, loading }] = useMutation(SIGNUP_MUTATION_WORKER);
  const [personalData, setPersonalData] = useState({});
  const [workInfoData, setWorkInfoData] = useState({});
  const [skillsData, setSkillsData] = useState({});
  const router = useRouter();
  const [recaptcha, setRecaptcha] = useState("");
  const { signIn } = useAuth();

  useEffect(() => {
    window.scroll(0, 0);
  }, [current]);

  const handleLoaded = (_) => {
    let token = "";
    return new Promise((reslove, reject) => {
      window.grecaptcha.ready((_) => {
        window.grecaptcha
          .execute(process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY, {
            action: "homepage",
          })
          .then((token) => {
            console.log("TOOOOOOKEN", token);
            reslove(token);
          })
          .catch((err) => console.log(err));
      });
    });
  };

  useEffect(() => {
    // Add reCaptcha
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_KEY}`;
    script.addEventListener("load", handleLoaded);
    document.body.appendChild(script);
  }, []);

  const nextStep = () => {
    {
      !current && setPersonalData(getFieldsValue());
    }
    {
      current && setWorkInfoData(getFieldsValue());
    }
    setCurrent(current + 1);
  };

  const prevStep = () => {
    {
      current == 1 && setWorkInfoData(getFieldsValue());
    }

    {
      current == 2 && setSkillsData(getFieldsValue());
    }
    setCurrent(current - 1);
  };

  /**
   * validationg PersonalInfo form if there is no error next form will load
   */
  const validatePersonalInfo = async (e) => {
    e.preventDefault();
    validateFields((err, values) => {
      if (!err) {
        nextStep();
      }
    });
  };

  /**
   * sign up worker method if there is no error in validation
   *
   */
  const registerWorker = async (e) => {
    e.preventDefault();

    await handleLoaded().then((token) => {
      validateFields(async (err, values) => {
        if (!err) {
          // call the mutation
          signUp({
            variables: {
              ...personalData,
              ...workInfoData,
              ...skillsData,
              ...values,
              firstName: personalData.firstName.toLowerCase(),
              lastName: personalData.lastName.toLowerCase(),
              email: personalData.email.toLowerCase(),
              recaptcha: token,
              referredBy: router?.query?.id && Number(router.query.id),
              facilityStreet: workInfoData.facilityStreet ? workInfoData.facilityStreet : personalData.homeStreet,
              city: workInfoData.city ? workInfoData.city : personalData.homeCity,
              state: { sName: workInfoData.state ? workInfoData.state : personalData.homeState },
              zipCode: workInfoData.zipCode ? workInfoData.zipCode : personalData.homeZipCode,
              homeState: { sName: personalData.homeState },
              channel: { sName: values.channel },
              skills: values.skills.map((skill) => {
                return { sName: skill };
              }),
              workPeriod: { sName: workInfoData.workPeriod },
            },
          })
            .then(({ data }) => {
              const { token, user } = data.signupWorker;
              signIn(token, user.id);
            })
            .then(() => {
              {
                admin
                  ? setVisible(false)
                  : router.push("thank-you-worker").then(() => router.reload());
              }
            });
        }
      });
    });
  };

  /**
   * validationg WorkInfo form data if there is no error next form will load
   */
  const validateWorkInfo = (e) => {
    e.preventDefault();

    form.validateFields((err, values) => {
      if (!err) {
        nextStep();
      }
    });
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div style={{ maxWidth: 1200, width: "100%" }}>
        {!admin && (
          <>
            <h1 className={styles.TitleContainer}>
              Register as a {brand.WORKER_TITLE ?? "HapiWorker"}
            </h1>
            <p className={styles.SubTitle}>
              You're 2 minutes away from taking the 1st step to becoming a{" "}
              {brand.APP_NAME ?? "HapiWorker"}!
            </p>
            <Head>
              <title>Become A {brand.APP_NAME ?? "HapiWorker"}</title>
            </Head>
          </>
        )}
        <div className={styles.StepsContainer}>
          <Steps className={styles.StepsCont}>
            <Step
              status={current >= 0 ? "finished" : ""}
              title="Personal Information"
              icon={<UserOutlined />}
            // onClick={() => setCurrent(0)}
            />

            <Step
              status={current >= 1 ? "finished" : ""}
              title="Work Information"
              icon={<IdcardOutlined />}
            // onClick={() => setCurrent(1)}
            />

            <Step
              status={current >= 2 ? "finished" : ""}
              title="Skills"
              icon={<ToolOutlined />}
            // onClick={() => setCurrent(2)}
            />
          </Steps>
        </div>
        <div className={styles.FormMainContainer}>
          <Form {...formItemLayout} style={{ width: "85%" }}>
            {current == 0 && (
              <PersonalInformation
                data={personalData}
                form={form}
                nextStep={validatePersonalInfo}
                states={states}
              />
            )}
            {current == 1 && (
              <WorkInformation
                form={form}
                nextStep={validateWorkInfo}
                prevStep={prevStep}
                states={states}
                workPeriods={workPeriods}
                data={workInfoData}
              />
            )}
            {current == 2 && (
              <Skills
                skills={skills}
                prevStep={prevStep}
                hearAboutUs={hearAboutUs}
                form={form}
                registerWorker={registerWorker}
                admin={admin}
                loading={loading}
                data={skillsData}
              />
            )}
          </Form>
        </div>
      </div>
    </div>
  );
};

const SignUpWorkerForm = Form.create({
  name: "signUpWorker",
})(SignUpWorker);
export default SignUpWorkerForm;
